import { render, staticRenderFns } from "./MemberAllMonthly.vue?vue&type=template&id=20fc280a&"
import script from "./MemberAllMonthly.vue?vue&type=script&lang=js&"
export * from "./MemberAllMonthly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports